import React, { Dispatch, SetStateAction, createContext } from "react";

interface BannerContextData {
  isMounted: boolean;
  setIsMounted: Dispatch<SetStateAction<boolean>>;
}

const BannerContext = createContext<BannerContextData>({} as BannerContextData);

export default BannerContext;
